import { Instagram as InstagramIcon, Youtube, ArrowUpRight } from "lucide-react";
import { Reveal, Eyebrow } from "./Reveal";
import { INSTAGRAM_TILES, INSTAGRAM_URL, INSTAGRAM_HANDLE, YOUTUBE_URL } from "../data/content";

export const Instagram = () => {
  const tiles = INSTAGRAM_TILES.map((src, i) => ({
    id: `tile-${i}`,
    media_url: src,
    permalink: INSTAGRAM_URL,
    caption: `Recent makeup work by Mrinalee, preview ${i + 1}`,
  }));

  return (
    <section id="instagram" data-testid="section-instagram" className="py-24 sm:py-32">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 text-center">
        <Reveal>
          <div className="flex justify-center">
            <Eyebrow index="11">Instagram</Eyebrow>
          </div>
          <h2 className="font-serif-ed font-normal text-3xl sm:text-4xl lg:text-5xl mt-6 tracking-[0.06em] text-[#2A1F16]">
            FOLLOW THE BEAUTY
          </h2>
          <p className="mt-4 text-[15px] text-[#6B5A49]">
            More looks, behind the scenes &amp; recent work —{" "}
            <a
              data-testid="instagram-handle-link"
              href={INSTAGRAM_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="text-[#B8893B] hover:text-[#96754D] transition-colors"
            >
              {INSTAGRAM_HANDLE}
            </a>
          </p>
        </Reveal>

        <Reveal delay={0.12}>
          <div className="mt-12 grid grid-cols-2 sm:grid-cols-4 gap-3">
            {tiles.map((item, i) => (
              <a
                key={item.id}
                data-testid={`instagram-tile-${i + 1}`}
                href={item.permalink}
                target="_blank"
                rel="noopener noreferrer"
                className="group relative overflow-hidden rounded-xl aspect-square block"
                aria-label={item.caption || `Open Mrinalee's Instagram — recent work ${i + 1}`}
              >
                <img
                  src={item.media_url}
                  alt={item.caption || `Recent makeup work by Mrinalee, preview ${i + 1}`}
                  loading="lazy"
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-[1.1s] ease-out"
                />
                <div className="absolute inset-0 bg-[#2A1F16]/0 group-hover:bg-[#2A1F16]/45 transition-colors duration-500 flex items-center justify-center">
                  <InstagramIcon className="text-[#2A1F16] opacity-0 group-hover:opacity-100 transition-opacity duration-500" size={22} />
                </div>
              </a>
            ))}
          </div>
        </Reveal>

        <Reveal delay={0.2}>
          <div className="mt-10 flex flex-wrap items-center justify-center gap-4">
            <a
              data-testid="instagram-follow-button"
              href={INSTAGRAM_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-3 text-[11px] uppercase tracking-[0.25em] bg-[#C9A25F] text-[#2A1F16] px-8 py-4 rounded-full hover:bg-[#B8893B] transition-colors duration-400"
            >
              <InstagramIcon size={15} />
              Follow {INSTAGRAM_HANDLE}
            </a>
            <a
              data-testid="youtube-channel-button"
              href={YOUTUBE_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-3 text-[11px] uppercase tracking-[0.25em] border border-[#2A1F16]/30 text-[#2A1F16] px-8 py-4 rounded-full hover:border-[#B8893B] hover:bg-[#2A1F16] hover:text-[#FBF6EE] transition-colors duration-400"
            >
              <Youtube size={15} />
              Watch on YouTube
              <ArrowUpRight size={13} />
            </a>
          </div>
        </Reveal>
      </div>
    </section>
  );
};
